import { TRANSIT_DAYS } from "@kupikupi/brand";
import { useNavigate, Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { TgHeader } from "../components/TgHeader";
import { TgMain } from "../components/TgMain";
import { TgPage } from "../components/TgPage";

const STEPS = ["step1", "step2", "step3", "step4", "step5", "step6"] as const;
const STEP_EMOJIS = ["🔗", "💳", "🛍", "📷", "✈", "🏠"] as const;

const FAQ_KEYS = ["q1", "q2", "q3", "q4"] as const;

export function BeginnerGuidePage() {
  const { t } = useTranslation("beginner_guide");
  const navigate = useNavigate();

  return (
    <TgPage tabbar={false}>
      <TgHeader title={t("breadcrumb.guide")} back />

      <div style={{ background: "var(--gradient-sky)", padding: "24px 16px", textAlign: "center" }}>
        <span
          style={{
            display: "inline-block",
            padding: "4px 12px",
            background: "rgba(255,255,255,.7)",
            color: "var(--color-primary-fill)",
            borderRadius: 999,
            fontSize: 10,
            fontWeight: 700,
          }}
        >
          {t("head.badge")}
        </span>
        <h1
          style={{
            fontFamily: "var(--font-display)",
            fontSize: 24,
            fontWeight: 900,
            margin: "10px 0 6px",
            lineHeight: 1.1,
          }}
        >
          {t("head.hero_line1")}
          <br />
          {t("head.hero_line2").split("<accent>").join("").split("</accent>").join("") !==
          t("head.hero_line2") ? (
            <>
              {t("head.hero_line2").split("<accent>")[0]}
              <span style={{ color: "var(--color-cta)" }}>
                {t("head.hero_line2").split("<accent>")[1]?.split("</accent>")[0]}
              </span>
              {t("head.hero_line2").split("</accent>")[1] ?? ""}
            </>
          ) : (
            t("head.hero_line2")
          )}
        </h1>
        <p style={{ fontSize: 11, color: "var(--color-text-muted)", margin: 0 }}>
          {t("head.hero_sub")}
        </p>
      </div>

      <div className="tg-body" style={{ flex: 1 }}>
        {STEPS.map((stepKey, i) => {
          const isLast = stepKey === "step6";
          return (
            <div
              key={stepKey}
              className="tg-card"
              style={{
                display: "grid",
                gridTemplateColumns: "36px 1fr",
                gap: 10,
                ...(isLast
                  ? {
                      background:
                        "linear-gradient(135deg,var(--color-primary-soft),#fff)",
                      border: "1.5px solid var(--color-primary)",
                    }
                  : {}),
              }}
            >
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: 10,
                  background: isLast
                    ? "var(--color-primary-fill)"
                    : "var(--color-primary-soft)",
                  color: isLast ? "#fff" : undefined,
                  display: "grid",
                  placeItems: "center",
                  fontSize: 18,
                }}
              >
                {STEP_EMOJIS[i]}
              </div>
              <div>
                <div
                  style={{
                    fontFamily: "var(--font-mono)",
                    fontSize: 9,
                    color: isLast
                      ? "var(--color-primary-fill)"
                      : "var(--color-text-muted)",
                    letterSpacing: "0.06em",
                    fontWeight: isLast ? 800 : 400,
                  }}
                >
                  {t(`${stepKey}.label` as never)}
                </div>
                <strong
                  style={{
                    fontSize: 13,
                    display: "block",
                    marginTop: 1,
                    color: isLast ? "var(--color-primary-fill)" : undefined,
                  }}
                >
                  {t(`${stepKey}.title` as never)}
                </strong>
                <div
                  style={{
                    fontSize: 10,
                    color: "var(--color-text-muted)",
                    marginTop: 3,
                    lineHeight: 1.5,
                  }}
                >
                  {t(`${stepKey}.body` as never, { days: TRANSIT_DAYS })}
                </div>
              </div>
            </div>
          );
        })}

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 6,
            marginTop: 6,
          }}
        >
          {FAQ_KEYS.map((k) => (
            <Link
              key={k}
              to={"/help" as never}
              style={{
                background: "var(--color-surface)",
                borderRadius: 8,
                padding: "8px 10px",
                fontSize: 11,
                textDecoration: "none",
                color: "inherit",
                display: "flex",
                gap: 6,
              }}
            >
              {t(`faq.${k}` as never)}
            </Link>
          ))}
        </div>
      </div>

      <TgMain onClick={() => navigate({ to: "/register" as never })}>{t("cta.register")}</TgMain>
    </TgPage>
  );
}
